import './rapportVehiculeValide.scss';
import { Table, Tag, Tooltip, Space, Button, Typography, Menu, Dropdown, notification, Card } from 'antd';
import { 
  CarOutlined, ApartmentOutlined, UserOutlined, FieldTimeOutlined, 
  EnvironmentOutlined, MenuOutlined, FileTextOutlined, DownOutlined, AppstoreOutlined, TrademarkOutlined 
} from '@ant-design/icons';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { renderDateTag } from '../../../../utils/renderTooltip';
import { getRapportCharroiVehicule } from '../../../../services/rapportService';

const { Text } = Typography;

const renderTextWithTooltip = (text, color = 'secondary', maxWidth = 160) => (
  <Tooltip title={text}>
    <div style={{ maxWidth, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
      <Text type={color}>{text}</Text>
    </div>
  </Tooltip>
);

// Formate une durée en minutes en min / h / jour
const formatDuration = (minutesTotal) => {
  if (minutesTotal == null) return '-';
  if (minutesTotal < 60) return `${minutesTotal} min`;
  
  const jours = Math.floor(minutesTotal / 1440);
  const heures = Math.floor((minutesTotal % 1440) / 60);
  const minutes = minutesTotal % 60;

  let result = '';
  if (jours > 0) result += `${jours} jour${jours > 1 ? 's' : ''} `;
  if (heures > 0) result += `${heures}h `;
  if (minutes > 0) result += `${minutes}m`;
  return result.trim();
};

const renderStatutHoraire = (nom_statut_bs, date_prevue) => {
  if (!nom_statut_bs || !date_prevue) return <Tag>-</Tag>;

  const now = moment();
  const prevue = moment(date_prevue);
  const diffMinutes = now.diff(prevue, 'minutes');

  let color = 'green';
  let label = `🟢 ${nom_statut_bs === 'BS validé' ? 'En attente' : ''}`;

  if (diffMinutes <= 60) {
    color = 'orange';
    label = `🟠 ${nom_statut_bs === 'BS validé' ? 'En attente' : ''} (${diffMinutes} min de retard)`;
  } else if (diffMinutes > 60) {
    color = 'red';
    label = `🔴 ${nom_statut_bs === 'BS validé' ? 'En attente' : ''} (${formatDuration(diffMinutes)} de retard)`;
  }

  return (
    <Tag color={color} style={{ fontWeight: 600 }}>
      {label}
    </Tag>
  );
};

const RapportVehiculeValide = () => {
    const [columnsVisibility, setColumnsVisibility] = useState({
        '#': true,
        'Motif': true,
        'Service': true,
        'Chauffeur': true,
        'Destination' : true,
        'Type véhicule' : true,
        'Immatriculation' : false,
        'Marque' : false,
        'Statut' : true,
        'Sortie prévue': true,
        'Retour prévu': false,
        'Durée moyenne' : true,
        'Commentaire': false
    });
    const [data, setData] = useState([]);
    const toggleColumnVisibility = (columnName, e) => {
    e.stopPropagation();
    setColumnsVisibility(prev => ({
      ...prev,
      [columnName]: !prev[columnName]
    }));
  };

          const fetchData = async() => {
              try {
                const { data } = await getRapportCharroiVehicule();
                setData(data.listeEnAttente);
              } catch (error) {
                notification.error({
                message: 'Erreur de chargement',
                description: 'Une erreur est survenue lors du chargement des données.',
              });
              }
          }
      
        useEffect(() => {
          fetchData()
          const handleVisibility = () => {
            if (!document.hidden) fetchData();
          };
          const interval = setInterval(() => {
            if (!document.hidden) fetchData();
          }, 30000);

          document.addEventListener('visibilitychange', handleVisibility);
          return () => {
            clearInterval(interval);
            document.removeEventListener('visibilitychange', handleVisibility);
          };
          // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

  const menus = (
    <Menu>
      {Object.keys(columnsVisibility).map(columnName => (
        <Menu.Item key={columnName}>
          <span onClick={(e) => toggleColumnVisibility(columnName,e)}>
            <input type="checkbox" checked={columnsVisibility[columnName]} readOnly />
            <span style={{ marginLeft: 8 }}>{columnName}</span>
          </span>
        </Menu.Item>
      ))}
    </Menu>
  );  


  const columns = [
    { title: '#', key: 'index', render: (_, __, index) => index + 1, width: 50 },
    {
      title: <Space><AppstoreOutlined style={{ color: '#1890ff' }} /><Text strong>Motif</Text></Space>,
      dataIndex: 'nom_motif_demande',
      key:'nom_motif_demande',
      render: (text) => renderTextWithTooltip(text),
      ellipsis: true,
        ...(columnsVisibility['Motif'] ? {} : { className: 'hidden-column' })
    },
    {
      title: <Space><ApartmentOutlined style={{ color: '#1d39c4' }} /><Text strong>Service</Text></Space>,
      dataIndex: 'nom_service',
      key:'nom_service',
      render: (text) => renderTextWithTooltip(text),
      ellipsis: true,
        ...(columnsVisibility['Service'] ? {} : { className: 'hidden-column' })
    },
    {
      title: <Space><UserOutlined style={{ color:'orange' }} /><Text strong>Chauffeur</Text></Space>,
      key:'chauffeur',
      render: (_, record) => renderTextWithTooltip(`${record.prenom_chauffeur} ${record.nom}`),
      ellipsis: true,
        ...(columnsVisibility['Chauffeur'] ? {} : { className: 'hidden-column' })
    },
    {
      title: <Space><EnvironmentOutlined style={{ color: 'red' }} /><Text strong>Destination</Text></Space>,
      dataIndex: 'nom_destination',
      key:'nom_destination',
      render: (text) => renderTextWithTooltip(text),
      ellipsis: true,
        ...(columnsVisibility['Destination'] ? {} : { className: 'hidden-column' })
    },
    {
      title: <Space><CarOutlined style={{ color: 'green' }} /><Text strong>Véhicule</Text></Space>,
      dataIndex:'nom_cat',
      key:'nom_cat',
      render: (text) => renderTextWithTooltip(text),
      ellipsis: true,
        ...(columnsVisibility['Type véhicule'] ? {} : { className: 'hidden-column' })
    },
    {
      title: 'Immatriculation',
      dataIndex:'immatriculation',
      key:'immatriculation',
      align: 'center',
       render: (text) => renderTextWithTooltip(text),
        ...(columnsVisibility['Immatriculation'] ? {} : { className: 'hidden-column' })
    },
    {
      title: 'Marque',
      dataIndex:'nom_marque',
      key: 'nom_marque',
      align: 'center',
      render: (text) => <Tag icon={<TrademarkOutlined />} color="blue">{text}</Tag>,
        ...(columnsVisibility['Marque'] ? {} : { className: 'hidden-column' })
    },
    {
      title: 'Sortie prévue',
      dataIndex:'date_prevue',
      key: 'date_prevue',
      align: 'center',
      render: (text) => renderDateTag(text),
        ...(columnsVisibility['Sortie prévue'] ? {} : { className: 'hidden-column' })

    },
    {
      title: 'Retour prévu',
      dataIndex:'date_retour',
      key:'date_retour',
      align: 'center',
      render: (text) => renderDateTag(text),
        ...(columnsVisibility['Retour prévu'] ? {} : { className: 'hidden-column' })
    },
    {
      title: <Space><FieldTimeOutlined style={{ color:'orange' }} /><Text strong>Statut</Text></Space>,
      key: 'statut_horaire',
      render: (_, record) => renderStatutHoraire(record.nom_statut_bs, record.date_prevue),
        ...(columnsVisibility['Statut'] ? {} : { className: 'hidden-column' })
    },
    {
      title: 'Durée moyenne',
      dataIndex: 'duree_moyenne_min',
      key: 'duree_moyenne_min',
      align: 'center',
      render: (val) => <Tag color="purple">{formatDuration(val)}</Tag>,
        ...(columnsVisibility['Durée moyenne'] ? {} : { className: 'hidden-column' })
    },
    {
      title: <Space><FileTextOutlined style={{ color:'orange' }} /><Text strong>Commentaire</Text></Space>,
      key:'commentaire',
      render: (_, record) => renderTextWithTooltip(`${record.commentaire}`),
      ellipsis: true,
        ...(columnsVisibility['Commentaire'] ? {} : { className: 'hidden-column' })
    }
  ];

  return (
    <div className="rapportVehiculeValide">
      <Card
        bordered={false}
        title={<Text style={{ fontSize: 18, fontWeight: 600, color: "#333" }}>En attente</Text>}
        extra={
          <Dropdown overlay={menus} trigger={['click']} placement="bottomRight" arrow>
                <Button
                icon={<MenuOutlined />}
                className="colonne-filtre-btn"
                type="primary"
                >
                Colonnes <DownOutlined />
                </Button>
          </Dropdown>
        }
      >
        <Table
          columns={columns}
          dataSource={data}
          rowKey={(record, index) => `${record.immatriculation}-${index}`}
          pagination={{ pageSize: 10 }}
          scroll={{ x: 'max-content' }}
          bordered
          size="middle"
          rowClassName={(record, index) => (index % 2 === 0 ? 'odd-row' : 'even-row')}
        />
      </Card>
    </div>
  );
};

export default RapportVehiculeValide;
